export default __webpack_public_path__ + "static/media/w_normal.54f17db1.svg";